"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecurringAppointmentSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _TimeslotSelector = _interopRequireDefault(require("./TimeslotSelector"));
var _SpinPlaceholder = require("../SpinPlaceholder");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ErrorMessage = function ErrorMessage(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "p-[24px]"
  }, children);
};
var RecurringAppointmentSelector = function RecurringAppointmentSelector(_ref2) {
  var value = _ref2.value,
    onSelect = _ref2.onSelect,
    intervalFrequency = _ref2.intervalFrequency,
    clinician = _ref2.clinician,
    cacheKey = _ref2.cacheKey;
  var _useRecurringAvailabi = (0, _utils.useRecurringAvailability)({
      clinician: clinician,
      intervalFrequency: intervalFrequency
    }, cacheKey),
    slots = _useRecurringAvailabi.data.recurringSlots,
    loading = _useRecurringAvailabi.loading,
    error = _useRecurringAvailabi.error;
  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_SpinPlaceholder.SpinPlaceholder, null);
  }
  if (!clinician.cronofySub) {
    return /*#__PURE__*/_react.default.createElement(ErrorMessage, null, "Your clinician hasn\u2019t updated their availability. Please contact", ' ', /*#__PURE__*/_react.default.createElement("a", {
      href: _utils.SUPPORT_URL
    }, "support@joinmonument.com"), " and we\u2019ll ensure you get an appointment scheduled as soon as possible.");
  }
  if (slots.length === 0) {
    return /*#__PURE__*/_react.default.createElement(ErrorMessage, null, "There aren\u2019t any upcoming time slots available. Please contact", ' ', /*#__PURE__*/_react.default.createElement("a", {
      href: _utils.SUPPORT_URL
    }, "support@joinmonument.com"), " and we\u2019ll ensure you get an appointment scheduled as soon as possible.");
  }
  if (error) {
    return /*#__PURE__*/_react.default.createElement(ErrorMessage, null, "There was a problem checking for available time slots. Please reload the page and try again.");
  }
  return /*#__PURE__*/_react.default.createElement(_TimeslotSelector.default, {
    slots: slots,
    value: value,
    onSelect: onSelect,
    pageSize: 7
  });
};
exports.RecurringAppointmentSelector = RecurringAppointmentSelector;